import store from '../store';
import * as userActionTypes from '../store/user/userActionTypes';
import * as alertActionTypes from '../store/alert/alertActionTypes';

export function errorHandler(error) {
  console.log('errorHandler');
  console.log(error);

  const status = error?.response?.status;

  if (status === 401 || status === 403) {
    store.dispatch({ type: userActionTypes.LOGOUT_REQUEST });

    store.dispatch({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: 'Session Expired!',
        text: status === 401 ? error.msg : 'User session expired, Please login again.',
        variant: status === 401 ? 'danger' : 'warning',
        outTimeMS: 6000,
      },
    });

    setTimeout(() => {
      window.location.href = '/login';
    }, 2000);
  } else {
    store.dispatch({
      type: alertActionTypes.SET_ALERT,
      msg: {
        title: 'Error!',
        text: error.msg,
        variant: 'danger',
        outTimeMS: 6000,
      },
    });
  }
}
